import { createStore, createEvent, sample, createEffect } from 'effector';
import { ModalState, OpenModalParams } from '@nx-frontend/shared/types';

let modalIdCounter = 0;

export const initialModal: ModalState = {
  id: modalIdCounter++,
  isShown: false,
  showCloseButton: true,
  closeButtonSize: 24,
  title: undefined,
  titleSize: undefined,
  isFullScreen: false,
  content: undefined,
  payload: undefined,
  position: false,
  additionalLayoutStyles: undefined,
  modalContainerStyles: undefined,
  escapeToClose: true,
  modalGradient: undefined,
  disabledClose: false,
};

export const openModalEvent = createEvent<OpenModalParams | void>();
export const closeModalEvent = createEvent<void>();
export const showModalEvent = createEvent();
// Close modal by id
export const resetModalPositionEvent = createEvent<number | void>();

export const $ModalStore = createStore<ModalState[]>([])
  .on(openModalEvent, (state, params = {}) => {
    const newModal = {
      ...initialModal,
      ...params,
      id: modalIdCounter++,
      isShown: false,
    };
    if (params && params.multipopup === false) {
      return [newModal];
    }
    return [...state, newModal];
  })
  .on(resetModalPositionEvent, (state, id) => {
    if (id === undefined) {
      // Сбрасываем позицию последнего модального компонента, если id не передан
      return state.map((modal, index) => {
        if (index === state.length - 1) {
          return { ...modal, position: false };
        }
        return modal;
      });
    }
    return state.map((modal) => (modal.id === id ? { ...modal, position: false } : modal));
  })
  .on(showModalEvent, (state) => {
    return state.map((modal) => {
      return {
        ...modal,
        isShown: true,
      };
    });
  })
  .on(closeModalEvent, (state) => {
    const lastModal = state[state.length - 1];
    if (lastModal && lastModal.onClose) {
      lastModal.onClose();
    }
    return state.slice(0, -1);
  });

// Селекторы для получения данных о модальных окнах
export const $isShownModal = $ModalStore.map((state) => state.some((modal) => modal.isShown));
export const $modalContents = $ModalStore.map((state) => state.map((modal) => modal.content));
export const $modalPositions = $ModalStore.map((state) => state.map((modal) => modal.position));

const delayEffect = createEffect((ms: number) => new Promise((resolve) => setTimeout(resolve, ms)));
sample({
  source: openModalEvent,
  target: delayEffect.prepend(() => 1),
});
sample({
  source: delayEffect.done,
  target: showModalEvent,
});
